RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';


    views.TableMetricChooser = RivalIQ.apps.Dashboard.widgets.table.TableMetricChooser.extend({

        disableOptgroups: false,
        saveTrackingConfig: RivalIQ.tracking.metric.SavedInsightsMetrics,

        metricsProp: function () {
            const me = this;

            const objectType = me.getProp('objectType');
            return `${objectType}_metrics`;
        },

        _getAttributesToSave: function () {
            const me = this;

            const attributesToSave = RivalIQ.apps.Dashboard.widgets.table.TableMetricChooser.prototype._getAttributesToSave.call(me);

            if (me.getProp('includeSummaryRow')) {
                attributesToSave.includeSummaryRow = true;
            }

            return attributesToSave;
        },

        getMetricsCollection: function () {
            const me = this;

            const objectType = me.getProp('objectType');

            const hasPaidEngagement = App.utils.hasInstagramPaidEngagement(me);
            const isInstagramPostObject = (objectType === RivalIQ.enums.insightsObjectType.post &&
                me.getProp('source') === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS &&
                me.getProp('analysisProperty') !== 'post_tag_ids');

            let definitions = me.getProp('metrics');
            const dashboardModel = (me.dashboardModel || me);
            const curation = dashboardModel.getCuration();

            if (!curation.isCustomDashboard) {
                definitions = App.utils.getWidgetDefinitions(me.getProps(), dashboardModel.isFocus());
            }

            const metrics = _.map(definitions, function (metric) {
                let config = metric;
                if (_.isString(metric)) {
                    config = {
                        property: metric
                    };
                }

                if (isInstagramPostObject) {
                    return _.defaults({
                        showProgressBar: true,
                        property: App.utils.getInstagramPaidEngagementMappedProperty(config.property, hasPaidEngagement)
                    }, config);
                }

                return config;
            });

            return new RivalIQ.apps.Favorites.collections.Metrics(metrics, {
                parse: true,
                baseMetric: (me.baseMetric || curation.baseMetric),
                source: me.getProp('source')
            });
        },

        onModalShown: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedInsightsMetricsModal);
        }
    });
});
